export const getState = (state) => state.toast;
export const getToasts = (state) => getState(state).toasts;
